import {
  FaChevronRight,
  FaShieldAlt,
  FaExclamationTriangle,
  FaChevronLeft,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { BusinessVerificationStatus } from "@/types/globalTypes";
import { useTranslation } from "react-i18next";
import i18n from "@/i18n";
import { isProduction } from "@/utils/helpers";

interface VerificationButtonLinkProps {
  verificationStatus: BusinessVerificationStatus;
}

const statusStyles = {
  verified: {
    bgColor: "bg-success",
    icon: <FaShieldAlt className="text-white text-[25px]" />,
    statusKey: "Completed",
    textColor: "text-success",
  },
  pending: {
    bgColor: "bg-warning",
    icon: <FaExclamationTriangle className="text-white text-[25px]" />,
    statusKey: "Pending",
    textColor: "text-warning",
  },
  "not-verified": {
    bgColor: "bg-error",
    icon: <FaExclamationTriangle className="text-white text-[25px]" />,
    statusKey: "Uncompleted",
    textColor: "text-error",
  },
};

function VerificationButtonLink({ verificationStatus }: VerificationButtonLinkProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const currentStatus = statusStyles[verificationStatus] || statusStyles["not-verified"];
  const translatedStatus = t(`store.verification.status.${currentStatus.statusKey}`);
  const title = t("store.verification.title", { status: translatedStatus });
  
  if(isProduction) return null

  return (
    <button
      onClick={() => navigate("/settings/verification")}
      className="text-start main-border mb-10 flex cursor-pointer items-center justify-between px-2 py-4 selection:bg-none sm:px-4 sm:py-0"
    >
      <div className="flex items-center gap-1">
        <div
          className={`relative m-2 flex aspect-square h-16 w-16 items-center justify-center rounded-full ${currentStatus.bgColor} sm:m-4`}
        >
          {currentStatus.icon}
        </div>

        <article className="flex flex-col">
          <h6 className={`text-colors-primary text-[15px] font-semibold ${currentStatus.textColor}`}>
            {title}
          </h6>
          <p className="text-[13px] text-gray-600">
            {t("store.verification.readyMessage")}
          </p>
          <span className="text-sm text-error">
            {t("store.verification.ownerOnly")}
          </span>
        </article>
      </div>
      <div>
        {i18n.language === "ar" ? (
          <FaChevronLeft className="text-[15px] text-gray-400" />
        ) : (
          <FaChevronRight className="text-[15px] text-gray-400" />
        )}
      </div>
    </button>
  );
}

export default VerificationButtonLink;
